import {ISubmissionProps} from '../../resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        total: 0,
        sum: 0,
    }

    submissions.forEach(submission => {
        if (submission.question10) {
            values.sum += submission.question10;
        }

        if (submission.question11) {
            values.total += submission.question11;
        }
    })

    if (values.total > 0) {
        return Number((values.sum / values.total * 100).toFixed(2));
    }

    return 0;
}